import React from 'react';
import Table from '../../../common/PDF/Table';
import { splitByThousands, addPercent } from '../../../../helpers/NumberFormatter';

export default ({data})=>{
	const columns=[
		{key: 'month_label', title: 'Period', width: 20, fontSize: 5},                   
		{key: 'phy_income_r12', title: 'Physical', width: 20, fontSize: 5, formatFn: splitByThousands},
		{key: 'dig_income_r12', title: 'Digital', width: 20, fontSize: 5, formatFn: splitByThousands},
		{key: 'nr_income_r12', title: 'NR', width: 20, fontSize: 5, formatFn: splitByThousands},
		{key: 'total_income_r12', title: 'Total', width: 20, fontSize: 5, formatFn: splitByThousands},
   ];
	   
	return <Table
		columns={columns}
		items={data}
	/>
}